import { createAtomObserver } from '@exodus/atoms';
import type { Definition } from '@exodus/dependency-types';

export const FIAT_PROVIDER_ATOM_EVENT = 'fiatProvider';

const createFiatRampProviderPlugin = ({ fiatProviderAtom, port }) => {
  const observer = createAtomObserver({
    atom: fiatProviderAtom,
    port,
    event: FIAT_PROVIDER_ATOM_EVENT,
  });

  return {
    onLoad: () => {
      observer.start();
    },
    onStop: () => {
      observer.unregister();
    },
  };
};

const fiatRampProviderPluginDefinition = {
  id: 'fiatRampProviderPlugin',
  type: 'plugin',
  factory: createFiatRampProviderPlugin,
  dependencies: ['fiatProviderAtom', 'port'],
} as const satisfies Definition;

export default fiatRampProviderPluginDefinition;
